<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content m-0">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">{{ 'user.upload.title' | translate }}</h4>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>

      <ul class="nav nav-tabs nav-bordered mx-2" role="tablist">
        <li class="nav-item" role="presentation">
          <a
            class="nav-link active"
            id="import-users-tab"
            data-bs-toggle="tab"
            data-bs-target="#import-users"
            type="button"
            role="tab"
            aria-controls="import-users"
            aria-selected="true"
          >
            <i
              class="mdi mdi-cloud-download-outline download-icon d-md-none d-block"
            ></i>
            <span class="d-none d-md-inline">{{ 'user.upload.title' | translate }}</span>
          </a>
        </li>
        <li class="nav-item" role="presentation">
          <a
            class="nav-link"
            id="rules-tab"
            data-bs-toggle="tab"
            data-bs-target="#rules"
            type="button"
            role="tab"
            aria-controls="rules"
            aria-selected="false"
          >
            <i class="mdi mdi-file-document-outline d-md-none d-block"></i>
            <span class="d-none d-md-inline">{{ 'user.upload.rulesTab' | translate }}</span>
          </a>
        </li>
      </ul>

      <div class="modal-body py-2 scroll">
        <div class="tab-content card-body" id="tabComponentsContent">
          <div
            class="tab-pane fade show active custom-scroll-bar card-upload-csv overflow-x-hidden"
            id="import-users"
            role="tabpanel"
            aria-labelledby="import-users-tab"
          >
            <div class="row justify-content-center mb-4">
              <div class="col-10 p-3">
                <div class="horizontal-steps">
                  <div class="horizontal-steps-content">
                    <div class="step-item" [class.current]="stepIndex() === 0">
                      <span>{{ 'user.upload.stepUpload' | translate }}</span>
                    </div>
                    <div class="step-item" [class.current]="stepIndex() === 1">
                      <span>{{ 'user.upload.stepMap' | translate }}</span>
                    </div>
                    <div class="step-item" [class.current]="stepIndex() === 2">
                      <span>{{ 'user.upload.stepPreview' | translate }}</span>
                    </div>
                  </div>
                  <div
                    class="process-line"
                    [style.width]="(stepIndex() / 2) * 100 + '%'"
                  ></div>
                </div>
              </div>

              <div>
                @switch (stepIndex()) {
                  @case (0) {
                    <div class="row mt-3 p-3">
                      <div class="rounded-3">
                        <label
                          for="dropzone-file"
                          class="dz-area w-100"
                          role="button"
                          [attr.aria-label]="'user.upload.dropzoneAriaLabel' | translate"
                        >
                          <div class="dz-inner text-center">
                            <i
                              class="mdi mdi-cloud-upload-outline mb-2 upload-icon text-muted font-24"
                            ></i>
                            <div
                              class="fw-semibold font-16 text-secondary mb-1"
                            >
                              {{ 'user.upload.clickToUpload' | translate }}
                            </div>
                            <small class="text-muted">
                              {{ 'user.upload.onlyCsvFiles' | translate }}
                            </small>
                          </div>
                        </label>

                        <input
                          id="dropzone-file"
                          type="file"
                          class="d-none"
                          accept=".csv"
                          (change)="handleSelectFile($event)"
                          #inputFile
                        />
                      </div>

                      @if (fileLoaded) {
                        <div
                          class="alert alert-info d-flex align-items-center justify-content-between gap-2 mt-3"
                          role="alert"
                        >
                          @if (!loading) {
                            <div class="d-flex align-items-center gap-2">
                              <i class="ri-file-user-line font-24"></i>
                              <div class="d-flex flex-column">
                                <span class="text-dark fw-semibold font-16">
                                  {{ file.name }}
                                </span>
                                <small>
                                  {{ formatBytes(file.size) }}
                                </small>
                              </div>
                            </div>
                            <div>
                              <i
                                class="mdi mdi-trash-can-outline text-danger font-18"
                                (click)="clearFile()"
                                role="button"
                              ></i>
                            </div>
                          } @else {
                            <div
                              class="spinner-border d-flex align-items-center justify-content-center"
                              role="status"
                            ></div>
                          }
                        </div>
                      }
                    </div>
                  }

                  @case (1) {
                    <div class="step-card mt-4 p-3">
                      <div class="d-flex align-items-center gap-2 mb-3">
                        <i
                          class="mdi mdi-table-column text-primary font-20"
                        ></i>
                        <span class="fw-semibold font-16">
                          {{ 'user.upload.mapColumnsInstruction' | translate }}
                        </span>
                      </div>

                      @if (!isMappingValid()) {
                        <div class="alert alert-warning py-2 mb-3" role="alert">
                          <i class="mdi mdi-alert-circle-outline me-1"></i>
                          <span [innerHTML]="'user.upload.mapRequiredFieldsWarning' | translate"></span>
                        </div>
                      }

                      <div class="table-responsive">
                        <table class="table table-centered mb-0">
                          <thead>
                            <tr>
                              <th>{{ 'user.upload.fileColumn' | translate }}</th>
                              <th>{{ 'user.upload.preview' | translate }}</th>
                              <th>{{ 'user.upload.targetField' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (map of mappings; track map.csvColumn; let i = $index) {
                              <tr>
                                <td class="fw-semibold">{{ map.csvColumn }}</td>
                                <td>
                                  <span class="text-muted">
                                    {{ map.sample || "—" }}
                                  </span>
                                </td>
                                <td>
                                  <mat-select
                                    class="form-control"
                                    [value]="map.mappedTo"
                                    (selectionChange)="onMappingChange(i, $event.value)"
                                  >
                                    @for (field of availableFields; track field.value) {
                                      <mat-option [value]="field.value">
                                        {{ field.label | translate }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  }

                  @case (2) {
                    @if (!!csvContent.length) {
                      <div class="step-card mt-4">
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <div class="mb-3">
                            <label class="form-label">
                              {{ 'user.upload.totalUsers' | translate }}
                            </label>
                            <h5 class="fw-semibold text-center">
                              {{ csvContent.length }}
                            </h5>
                          </div>
                          <div class="mb-3">
                            <label class="form-label">
                              {{ 'user.upload.usersWithoutError' | translate }}
                            </label>
                            <h5 class="fw-semibold text-center">
                              {{ csvContent.length - getErrorCount() }}
                            </h5>
                          </div>
                          <div class="mb-3">
                            <label class="form-label">
                              {{ 'user.upload.usersWithError' | translate }}
                            </label>
                            <h5 class="fw-semibold text-center">
                              {{ getErrorCount() }}
                            </h5>
                            @if (getErrorCount() > 0) {
                              <div class="mb-3 d-flex align-items-end">
                                <button
                                  class="btn btn-sm btn-outline-danger"
                                  type="button"
                                  (click)="removeAllErrors()"
                                >
                                  <i
                                    class="mdi mdi-delete-sweep-outline me-1"
                                  ></i>
                                  {{ 'user.upload.removeAllErrors' | translate }}
                                </button>
                              </div>
                            }
                          </div>
                        </div>

                        <div class="table-responsive">
                          <table class="table table-hover table-centered mb-0">
                            <thead>
                              <tr>
                                <th class="text-primary-emphasis">{{ 'user.upload.name' | translate }}</th>
                                <th class="text-primary-emphasis">{{ 'user.upload.phone' | translate }}</th>
                                <th class="text-primary-emphasis">{{ 'user.upload.email' | translate }}</th>
                                <th class="text-primary-emphasis">{{ 'user.upload.tags' | translate }}</th>
                                <th class="sr-only"></th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (row of paginatedContent; track row) {
                                <tr role="row">
                                  <td>
                                    <span
                                      [ngClass]="{
                                        'text-danger': row['hasError'],
                                        'text-dark': !row['hasError'],
                                      }"
                                    >
                                      {{ row["name"] }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      [ngClass]="{
                                        'text-danger': row['hasError'],
                                        'text-dark': !row['hasError'],
                                      }"
                                    >
                                      {{ row["phone"] }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      [ngClass]="{
                                        'text-danger': row['hasError'],
                                        'text-dark': !row['hasError'],
                                      }"
                                    >
                                      {{ row["email"] }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      [ngClass]="{
                                        'text-danger': row['hasError'],
                                        'text-dark': !row['hasError'],
                                      }"
                                    >
                                      {{ row["tags"] }}
                                    </span>
                                  </td>
                                  <td class="py-3 pl-3 pr-4 text-right text-sm">
                                    <div role="none">
                                      <a
                                        href="javascript:void(0)"
                                        class="text-danger text-decoration-none"
                                        role="menuitem"
                                        (click)="delete(row)"
                                      >
                                        <i
                                          class="mdi mdi-trash-can-outline"
                                        ></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                                <tr class=""></tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <mat-paginator
                        [length]="csvContent.length"
                        [pageSize]="pageSize"
                        (page)="handlePage($event)"
                      ></mat-paginator>
                    }
                  }
                }
              </div>
            </div>
          </div>

          <!-- Rules  -->
          <div
            class="tab-pane fade show custom-scroll-bar card-upload-csv overflow-x-hidden"
            id="rules"
            role="tabpanel"
            aria-labelledby="rules-tab"
          >
            <div class="col-xs-12 overflow-x-hidden">
              <div class="row">
                <div class="p-3">
                  <div class="mb-3 custom-scroll-bar card-rules">
                    <div class="mt-3">
                      <p class="mb-3">
                        {{ 'user.upload.rulesIntro' | translate }}
                      </p>

                      <p class="fw-bold mb-1">
                        {{ 'user.upload.rulesSection1Title' | translate }}
                      </p>
                      <ul class="list-circle ps-4 mb-3">
                        <li>{{ 'user.upload.rulesSection1Item1' | translate }}</li>
                        <li [innerHTML]="'user.upload.rulesSection1Item2' | translate"></li>
                        <li [innerHTML]="'user.upload.rulesSection1Item3' | translate"></li>
                      </ul>

                      <p class="fw-bold mb-1">
                        {{ 'user.upload.rulesSection2Title' | translate }}
                      </p>
                      <ul class="list-circle ps-4 mb-3">
                        <li>
                          {{ 'user.upload.rulesSection2Item1' | translate }}
                        </li>
                        <li>
                          {{ 'user.upload.rulesSection2Item2' | translate }}
                        </li>
                        <li>
                          {{ 'user.upload.rulesSection2Item3' | translate }}
                        </li>
                      </ul>

                      <p class="fw-bold mb-1">
                        {{ 'user.upload.rulesSection3Title' | translate }}
                      </p>
                      <ul class="list-circle ps-4 mb-3">
                        <li>
                          {{ 'user.upload.rulesSection3Item1' | translate }}
                        </li>
                        <li>
                          {{ 'user.upload.rulesSection3Item2' | translate }}
                        </li>
                      </ul>

                      <p class="fw-bold mb-1">{{ 'user.upload.rulesSection4Title' | translate }}</p>
                      <ul class="list-circle ps-4 mb-3">
                        <li [innerHTML]="'user.upload.rulesSection4Item1' | translate"></li>
                        <li>
                          {{ 'user.upload.rulesSection4Item2' | translate }}
                        </li>
                        <li>
                          {{ 'user.upload.rulesSection4Item3' | translate }}
                        </li>
                        <li>{{ 'user.upload.rulesSection4Item4' | translate }}</li>
                        <li>{{ 'user.upload.rulesSection4Item5' | translate }}</li>
                      </ul>

                      <p class="mb-0">
                        {{ 'user.upload.rulesOutro' | translate }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div>
          <div class="col-12 gap-2 d-flex justify-content-end">
            <button class="btn btn-outline-secondary" (click)="close()">
              {{ 'user.upload.cancel' | translate }}
            </button>

            @if (stepIndex() > 0) {
              <button class="btn btn-dark" (click)="prev()">{{ 'user.upload.back' | translate }}</button>
            }

            @if (stepIndex() === 0) {
              <button
                class="btn btn-primary"
                [disabled]="!fileLoaded || loading"
                (click)="onContinueFromUpload()"
              >
                @if (loading) {
                  <span
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {{ 'user.upload.wait' | translate }}
                } @else {
                  {{ 'user.upload.continue' | translate }}
                }
              </button>
            } @else if (stepIndex() === 1) {
              <button
                class="btn btn-primary"
                (click)="onContinueFromMapping()"
                [disabled]="!isMappingValid()"
              >
                {{ 'user.upload.continue' | translate }}
              </button>
            } @else if (stepIndex() === 2) {
              <button
                class="btn btn-primary"
                type="submit"
                [disabled]="
                  loading || !csvContent.length || getErrorCount() > 0
                "
                (click)="save()"
              >
                @if (loading) {
                  <mat-spinner
                    [diameter]="15"
                    [color]="'accent'"
                    mode="indeterminate"
                  />
                } @else {
                  {{ 'user.upload.import' | translate }}
                }
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
